export const DOMAIN = process.env.NODE_ENV === 'development' ? "http://localhost:3000" : "https://sbkegs.com"